import i18n from './attribute-modification-key.properties';

const ATTRIBUTE_MODIFICATION_KEYS = [
  'NAME',
  'FORMAT',
  'VALUE_DISTRIBUTION',
  'LOCAL_HIERARCHY_LEVEL',
  'USE_LOCAL_HIERARCHY_LEVEL',
  'USE_SCALE_DEPENDENT_HIERARCHY_LEVEL',
  'MEASURE_AGGREGATION',
  'TOTALS_AGGREGATION',
  'UNIQUE_VALUES_CLASSIFICATION_COLOR_PALETTE',
  'CLASSIFICATION_MODE',
  'POSTGIS_RASTER_PRECONFIGURED_MAPPING_ID',
  'POSTGIS_RASTER_VALUE_RANGE_MIN',
  'POSTGIS_RASTER_VALUE_RANGE_MAX',
  // Single color is currently the only graphical property stored as a geometry attribute modification.
  // Please register other new map data view graphical properties as data view settings
  // or as layer settings in case they should be available also for the other layer types.
  // The classification settings are stored as classification attribute modifications, which is fine.
  'SINGLE_COLOR',
  'TABLE_CELL_PRESENTATION',
  'TABLE_VISUAL_GROUPING',
  'TABLE_COLLAPSE_GROUP',
  'TABLE_LINE_BREAKING',
  'TABLE_FRACTION_CALCULATION',
  'FRACTION_FORMAT',
  'SHOW_SUBTOTALS',
  'TOP_N_ROWS_ENABLED',
  'TOP_N_SORT_ORDER',
  'TOP_N_ROWS_MAX_ROWS_PER_GROUP',
  'TOP_N_MEASURE',
  'TOP_N_ROWS_SHOW_COLLAPSED_OTHERS',
  'TOP_N_OTHERS_LABEL',
  'SUBTOTAL_LABEL',
  'SORT_HIERARCHY_LEVEL',
  'SORT_ORDER',
  'REQUEST_ALL_DIMENSION',
  'COLUMNS_SIZE',
  'VISIBLE',
  'SEMANTIC_NAME',
  'SORT_DIRECTION',
  'IGNORE_SORT_ATTRIBUTE',
  'NULL_VALUE_DISPLAY_TEXT',
  'CLASSIFICATION_NAME',
  'CLASSIFICATION_TYPE',
  'CLASSIFICATION_CLASS_LABEL',
  'CLASSIFICATION_OTHER_VALUES_COLOR',
  'CLASSIFICATION_OTHER_VALUES_SYMBOL_SIZE',
  'CLASSIFICATION_OTHER_VALUES_IMAGE',
  'CLASSIFICATION_OTHER_VALUES_LABEL',
  'REFERENCE_VALUE',
  'REFERENCE_VALUE_ENABLED',
  'UNIQUE_VALUES_CLASSIFICATION_ASSIGNMENT_TYPE',
  'INTERVAL_CLASSIFICATION_METHOD',
  'INTERVAL_CLASSIFICATION_NUMBER_OF_CLASSES',
  'INTERVAL_CLASSIFICATION_INTERVAL_SIZE',
  'INTERVAL_CLASSIFICATION_LOWER_BOUND',
  'INTERVAL_CLASSIFICATION_UPPER_BOUND',
  'INTERVAL_CLASSIFICATION_GRADIENT_ID',
  'INTERVAL_CLASSIFICATION_REVERSED_GRADIENT',
  'INTERVAL_CLASSIFICATION_ROUND_CLASS_LIMITS',
  'INTERVAL_CLASSIFICATION_HIGH_VALUE_CLASSES_FIRST',
  'INTERVAL_CLASSIFICATION_CLASS_BOUNDARIES',
  'INTERVAL_CLASSIFICATION_SYMBOL_SIZE_RANGE',
  'TEXT_VIEW_WITH_DATA_DIMENSION_AGGREGATION',
  'TEXT_VIEW_WITH_DATA_LIST_VALUE_SEPARATOR',
  'TEXT_VIEW_WITH_DATA_LIST_VALUE_DISPLAY_LIMIT',
  'WEBPAGE_DIMENSION_AGGREGATION',
  'COLOR_BAND_ENABLED',
  'PRECONDITION_OPERATOR',
  'PRECONDITION_VALUE',
] as const;

/** @see net/disy/cadenza/workbook/model/AttributeModificationKey.java */
export type AttributeModificationKey = (typeof ATTRIBUTE_MODIFICATION_KEYS)[number];

/** @deprecated Use the type instead. */
export const AttributeModificationKey = Object.assign(
  Object.fromEntries(ATTRIBUTE_MODIFICATION_KEYS.map((k) => [k, k])),
  { values: ATTRIBUTE_MODIFICATION_KEYS, i18n },
);
